<div class="message-form-container">
  <p-fileUpload
    [maxFileSize]="MAX_FILE_SIZE"
    [accept]="accept"
    [multiple]="true"
    [auto]="false"
    [disabled]="false"
    [customUpload]="true"
    invalidFileTypeMessageSummary="Invalid file type"
    invalidFileTypeMessageDetail="Please select supported file type"
    (onError)="isUploading = false"
    (onUpload)="isUploading = false"
    (onSelect)="onSelectedFiles($event)"
  >
    <ng-template pTemplate="content">
      <ng-content></ng-content>
    </ng-template>
  </p-fileUpload>
</div>
